export default __webpack_public_path__ + "static/media/Page.059b8ebf.svg";